import { createFileRoute } from "@tanstack/react-router";

import { ContactAside } from "@/features/contact/modules/contact-form/contact-aside";
import { ContactForm } from "@/features/contact/modules/contact-form/contact-form";
import { PortalHead, PortalPage } from "@/features/portal/components/portal-chrome";
import { displayTitle, Eyebrow } from "@/features/portal/components/portal-ui";
import { pageMeta } from "@/lib/seo";
import { cn } from "@/lib/utils";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/contact/")({
  head: () => ({ meta: pageMeta({ title: m.landing_nav_contact(), description: m.seo_contact_description() }) }),
  loader: () => ({ crumb: m.landing_nav_contact() }),
  component: ContactPage,
});

/** Writing to the people who run the app, as opposed to a coach on it (that is `/<slug>/contact`). */
function ContactPage() {
  return (
    <PortalPage
      head={
        <PortalHead>
          <div className="relative mx-auto max-w-[820px] px-1 pt-14 pb-4 text-center md:pt-20 md:pb-8">
            <Eyebrow>{m.landing_nav_contact()}</Eyebrow>
            <h1 className={cn(displayTitle, "mt-6")}>{m.contact_hero_title()}</h1>
            <p className="mx-auto mt-6 max-w-[52ch] text-lg leading-[1.55] text-pretty text-muted-foreground">
              {m.contact_hero_lede()}
            </p>
          </div>
        </PortalHead>
      }
    >
      <div className="mt-3 grid items-start gap-3 lg:grid-cols-[minmax(0,1.35fr)_minmax(0,1fr)]">
        <ContactForm />
        <ContactAside />
      </div>
    </PortalPage>
  );
}
